import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const timeSlotsSlice = createSlice({
    name: 'timeSlots',
    initialState,
    reducers: {
        setTimeSlots(state, action) {
            return action.payload;
        },
        removeTimeSlots(state) {
            return initialState;
        },
    },
});

export const { setTimeSlots, removeTimeSlots } = timeSlotsSlice.actions;
export default timeSlotsSlice.reducer;